import { useCallback } from 'react';
import createPathMatcher from 'path-match';
import { setSessionAreaName, setSessionCollectionName } from '@/platform-services/session';
import { Routing } from '@/constants';
import { useLocationChanged } from '@/routing/hooks';
const modelManagerPathMatcher = createPathMatcher({ end: false })(Routing.MODEL_MANAGER_PATH);
export const useUpdateAreaOnLocationChanged = () => {
    const updateArea = useCallback((location) => {
        let collection;
        let area;
        const match = modelManagerPathMatcher(location.pathname);
        if (match && (match === null || match === void 0 ? void 0 : match.collection) && match.collection !== Routing.CREATE_MODEL_SEGMENT) {
            collection = match.collection;
        }
        if (match && (match === null || match === void 0 ? void 0 : match.area) && match.area !== Routing.CREATE_MODEL_SEGMENT) {
            area = match.area;
        }
        if (collection) {
            setSessionCollectionName(collection);
            if (area) {
                setSessionAreaName(area);
            }
        }
    }, []);
    useLocationChanged(updateArea);
};
